export const SECONDARY_PROMPTS_COUNT = 6;
